import ApiHandler from "./ApiHandler";

const DocumentType = {
  getAll: async () => await ApiHandler.i.auth().get('/document-type'),
};

export default DocumentType;